import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { MIRRORS_LIST_PERMISSIONS } from '@modules/mirrors-list/constants';
import {
  MIRRORS_LIST_CREATE_JS_ROUTE_NAME,
  MIRRORS_LIST_CREATE_NO_JS_ROUTE_NAME,
} from '@modules/mirrors-list/submodules/create/constants';
import {
  MIRRORS_LIST_CREATE_JS_MANUALLY_ROUTE_NAME,
  MIRRORS_LIST_CREATE_NO_JS_MANUALLY_ROUTE_NAME,
  TRANSLATION_GROUP_MIRRORS_CREATE_MANUALLY,
} from '@modules/mirrors-list/submodules/create/submodules/manually/constants';
import getTranslationKeys from '@modules/mirrors-list/submodules/create/submodules/manually/translations';

export class MirrorAddManuallyModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(MIRRORS_LIST_CREATE_JS_ROUTE_NAME, {
      name: MIRRORS_LIST_CREATE_JS_MANUALLY_ROUTE_NAME,
      path: 'manually',
      permission: MIRRORS_LIST_PERMISSIONS.CREATE,
      component: () => import('@modules/mirrors-list/submodules/create/submodules/manually/pages/MirrorAddManuallyPage/MirrorAddManuallyPage.vue'),
    });

    router.addChildRoute(MIRRORS_LIST_CREATE_NO_JS_ROUTE_NAME, {
      name: MIRRORS_LIST_CREATE_NO_JS_MANUALLY_ROUTE_NAME,
      path: 'manually',
      permission: MIRRORS_LIST_PERMISSIONS.CREATE,
      component: () => import('@modules/mirrors-list/submodules/create/submodules/manually/pages/MirrorAddManuallyPage/MirrorAddManuallyPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_MIRRORS_CREATE_MANUALLY, getTranslationKeys);
  }
}
